module.exports = __webpack_public_path__ + "img/certificate-icon.41d80238.png";